import Head from "next/head";
import { fromUrl, toUrl } from "common/src/Aperture.bs";
import { make as ItemPage } from "../../src/items/ItemPage.bs";
import { make as ItemsPage } from "../../src/items/ItemsPage.bs";
import { getApertures } from "../../utils/static-paths";
import { renderFull, toApiUrl as patchToUrl } from "common/src/Patch.bs";
import { items } from "common/src/data/Data14.bs";

export default function Items({ itemId, itemData, statsData, aperture }) {
  if (itemId != null) {
    return (
      <>
        <Head>
          <title>{`TFT Items Stats - Best Items for Set 14 Patch ${renderFull(
            aperture.patch,
          )}`}</title>
        </Head>
        <ItemPage
          aperture={aperture}
          statsData={statsData}
          itemData={itemData}
          itemId={itemId}
        />
      </>
    );
  } else {
    return (
      <>
        <Head>
          <title>{`TFT Items Stats - Best Items for Set 14 Patch ${renderFull(
            aperture.patch,
          )}`}</title>
        </Head>
        <ItemsPage statsData={statsData} />
      </>
    );
  }
}

export async function getStaticPaths() {
  const params = getApertures();
  return {
    paths: [],
    // paths: params.map((params) => ({
    //   params: params,
    // })),
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, locale }) {
  if (params.slug?.[0] && items[params.slug[0]] != null) {
    const itemId = params.slug[0];
    const aperture = fromUrl(params.slug.slice(1));

    const itemResp = await fetch(
      `https://d3.tft.tools/stats2/item/${
        aperture.queue
      }/${itemId}/${patchToUrl(aperture.patch)}/${aperture.rankGroup}`,
    );
    const itemData = await itemResp.json();

    const statsResp = await fetch(
      `https://d3.tft.tools/stats2/general/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const statsData = await statsResp.json();

    return {
      props: {
        aperture,
        statsData,
        itemId,
        itemData,
      },
      revalidate: 3600,
    };
  } else {
    const aperture = fromUrl(params.slug || []);

    const statsResp = await fetch(
      `https://d3.tft.tools/stats2/general/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const statsData = await statsResp.json();

    return {
      props: {
        aperture,
        statsData,
      },
      revalidate: 3600,
    };
  }
}
